/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../ContactInformation.module.scss'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const DateOfBirth = ({
  t,
  validateDateOfBirth,
  dateOfBirthError,
  dateOfBirthValid,
  dateOfBirthDayEl,
  dateOfBirthMonthEl,
  dateOfBirthYearEl,
  setIsError,
}) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const dateOfBirth = useSelector((state) => state.app.contactInformation.dateOfBirth)

  const handleDateOfBirthDay = (e) => {
    try {
      const regex = RegExp(/^\d+$/)
      if (regex.test(dateOfBirthDayEl.current.value)) {
        let value = dateOfBirthDayEl.current.value
        if (value !== '' && parseInt(value) > 0 && parseInt(value) < 10) {
          value = '0' + value.toString()
        } else {
          value = value.substr(1)
        }
        dispatch(
          changeObjectPropertyAction(
            'contactInformation',
            'dateOfBirth',
            `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${value}`
          )
        )
        // validateDateOfBirth()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleDateOfBirthMonth = (e) => {
    try {
      dispatch(
        changeObjectPropertyAction(
          'contactInformation',
          'dateOfBirth',
          `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`
        )
      )
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleDateOfBirthYear = (e) => {
    try {
      const regex = RegExp(/^$|^\d+$/)
      if (regex.test(dateOfBirthYearEl.current.value)) {
        dispatch(
          changeObjectPropertyAction(
            'contactInformation',
            'dateOfBirth',
            `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`
          )
        )
        // validateDateOfBirth()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurDateOfBirth = () => {
    if (dateOfBirth.length < 3 || dateOfBirth.length > 9) {
      SetIsFocussed(false)
    }
    validateDateOfBirth()
  }

  const months = [
    { name: t('contact_information.month_jan'), value: 1 },
    { name: t('contact_information.month_feb'), value: 2 },
    { name: t('contact_information.month_mar'), value: 3 },
    { name: t('contact_information.month_apr'), value: 4 },
    { name: t('contact_information.month_may'), value: 5 },
    { name: t('contact_information.month_jun'), value: 6 },
    { name: t('contact_information.month_jul'), value: 7 },
    { name: t('contact_information.month_aug'), value: 8 },
    { name: t('contact_information.month_sep'), value: 9 },
    { name: t('contact_information.month_oct'), value: 10 },
    { name: t('contact_information.month_nov'), value: 11 },
    { name: t('contact_information.month_dec'), value: 12 },
  ]

  const formatMonth = (monthNumber) => {
    return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`
  }

  return (
    <div
      className={[
        'ns-form-group',
        dateOfBirthValid !== true && dateOfBirthValid !== '' ? 'ns-form-group-message-error' : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <div className="ns-label-wrapper">
        <label className="ns-label" htmlFor="DateOfBirth">
          {t('contact_information.date_of_birth')}
        </label>
      </div>
      <div id="date-of-birth-hint" className="ns-hint" style={{ marginTop: '5px' }}>
        {t('contact_information.dob_example')}
      </div>
      {dateOfBirthValid === true || dateOfBirthValid === '' ? null : (
        <span id="date-of-birth-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
          <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
          <span className="ns-visually-hidden">{t('shared.error')}</span> {t(dateOfBirthError)}
        </span>
      )}
      <div className={styles['date-align']}>
        <div className={styles['day_field']}>
          <label className="control-label" htmlFor="Date" style={{ marginBottom: '0px' }}>
            {t('contact_information.dd')}
          </label>
        </div>
        <div className={styles['month_field']}>
          <label className="control-label" htmlFor="Month" style={{ marginBottom: '0px' }}>
            {t('contact_information.mm')}
          </label>
        </div>
        <div className={styles['year_field']}>
          <label className="control-label" htmlFor="Year" style={{ marginBottom: '0px' }}>
            {t('contact_information.yyyy')}
          </label>
        </div>
      </div>
      <div className={styles['date-align']}>
        <input
          ref={dateOfBirthDayEl}
          className={['fw-4', dateOfBirthValid !== true && dateOfBirthValid !== '' ? 'ns-input--error' : '', styles['day_field']].join(' ')}
          id="DateOfBirthDay"
          name="DateOfBirthDay"
          type="text"
          aria-describedby="date-of-birth-day"
          aria-label={t('contact_information.dd')}
          onChange={handleDateOfBirthDay}
          // onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          value={dateOfBirth.split('-')[2] || ''}
          autoComplete="off"
          maxLength="150"
        />
        <select
          ref={dateOfBirthMonthEl}
          id="date-of-birth-month"
          aria-labelledby="date-of-birth-month"
          aria-label={t('contact_information.mm')}
          value={dateOfBirth.split('-')[1] || ''}
          onChange={handleDateOfBirthMonth}
          // onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          className={[dateOfBirthValid !== true && dateOfBirthValid !== '' ? 'ns-select--error' : '', styles['month_field']].join(' ')}
        >
          <option value="">{t('contact_information.select_month')}</option>
          {months.map((month) => (
            <option key={month.value} value={formatMonth(month.value)}>
              {month.name}
            </option>
          ))}
        </select>
        {/* <input
        ref={dateOfBirthMonthEl}
        className={[
          'fw-4',
          dateOfBirthValid === true ? 'ns-input--success' : '',
          dateOfBirthValid !== true && dateOfBirthValid !== '' ? 'ns-input--error' : '',
          styles['date_for_birth_year'],
        ].join(' ')}
        id="DateOfBirthMonth"
        name="DateOfBirthMonth"
        type="text"
        aria-describedby="date-of-birth-month"
        onChange={handleDateOfBirthMonth}
        aria-label={t('contact_information.mm')}
        onBlur={onBlurDateOfBirth}
        onFocus={() => SetIsFocussed(true)}
        value={dateOfBirth.split('-')[1] || ''}
        autoComplete="off"
        maxLength="150"
      /> */}

        <input
          ref={dateOfBirthYearEl}
          className={['fw-4', dateOfBirthValid !== true && dateOfBirthValid !== '' ? 'ns-input--error' : '', styles['year_field']].join(
            ' '
          )}
          id="DateOfBirthYear"
          name="DateOfBirthYear"
          type="text"
          aria-describedby="date-of-birth-year"
          onChange={handleDateOfBirthYear}
          // onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          value={dateOfBirth.split('-')[0] || ''}
          aria-label={t('contact_information.yyyy')}
          autoComplete="off"
          maxLength="4"
        />
        {/* {dateOfBirthValid === true && (
          <div style={{ display: 'inline-flex', marginLeft: '1rem', alignItems: 'center' }}>
            <i className="fa fa-check-circle fa-lg" aria-hidden="true"></i>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default withTranslation('common')(DateOfBirth)
